// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';
import { createClientCredential } from '../../api/commonServices';
import { useErrorContext } from '../../errorHandler/context/ErrorContext';
import { AppError, type ApiError } from '../../errorHandler/errors';
import type { CreateClientCredentialResponse, ClientCredentialClientType } from '../../api/types';

type UseCreateClientCredentialProps = {
  setToken: (token: string) => void;
  isSetup: boolean;
  clientType: ClientCredentialClientType;
};

const useCreateClientCredential = ({ setToken, isSetup, clientType }: UseCreateClientCredentialProps) => {
  const { emitError } = useErrorContext();

  return useMutation({
    mutationFn: async (integrationId: string): Promise<CreateClientCredentialResponse> => {
      return createClientCredential(
        {
          clientType: clientType,
          installationTokenExpirationInMinutes: 60,
          accessTokenExpirationInMinutes: 15,
          integrationId: integrationId,
        },
        isSetup,
      );
    },
    onSuccess: (data) => {
      setToken(data.clientCredential.installationTokenValue);
    },
    onError: (e: ApiError) => {
      emitError(new AppError(e));
    },
  });
};

export default useCreateClientCredential;
